import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Footer, Header } from "@dp/web";
import React from "react";
var LoginPopup = /*#__PURE__*/React.lazy(function () {
  return import("@dp/web").then(function (module) {
    return {
      "default": module.LoginPopup
    };
  });
});
var SuccessDialog = /*#__PURE__*/React.lazy(function () {
  return import("@dp/web").then(function (module) {
    return {
      "default": module.SuccessDialog
    };
  });
});
var ErrorDialog = /*#__PURE__*/React.lazy(function () {
  return import("@dp/web").then(function (module) {
    return {
      "default": module.ErrorDialog
    };
  });
});
var Loading = /*#__PURE__*/React.lazy(function () {
  return import("@dp/web").then(function (module) {
    return {
      "default": module.Loading
    };
  });
});

var HeaderFooterLayout = function HeaderFooterLayout(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props.brand ? /*#__PURE__*/_jsx(Header, {
      desktopLeftNavComp: /*#__PURE__*/_jsx("ul", {
        className: "navbar-nav",
        children: /*#__PURE__*/_jsx("a", {
          children: /*#__PURE__*/_jsx("li", {
            className: "",
            children: /*#__PURE__*/_jsx("span", {
              className: "nav-link ",
              children: /*#__PURE__*/_jsx("span", {
                className: "sr-only",
                children: "(current)"
              })
            })
          })
        })
      }),
      mobileLeftNavComp: /*#__PURE__*/_jsx("a", {
        href: "/menu-listing",
        children: /*#__PURE__*/_jsx("div", {
          className: "return-menu",
          children: /*#__PURE__*/_jsx("span", {
            className: "return-menu-link",
            children: "Menu"
          })
        })
      })
    }) : null, props.children, /*#__PURE__*/_jsx(Loading, {}), /*#__PURE__*/_jsx(React.Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(LoginPopup, {})
    }), /*#__PURE__*/_jsx(SuccessDialog, {}), /*#__PURE__*/_jsx(ErrorDialog, {}), /*#__PURE__*/_jsx(Footer, {
      className: "fixed-botton version"
    })]
  });
};

export default HeaderFooterLayout;